import type {FC} from 'react';
import {cn} from '../../../../../../lib/classname';
import {CommonLink} from '../../../../../../shared/components/CommonLink';
import {Button} from './Button';

type Props = {
  className?: string;
};
export const GssktResearchLink: FC<Props> = ({className}) => {
  return (
    <Button
      as={CommonLink}
      isExternal={true}
      href="https://ri.gaishishukatsu.com"
      target="_blank"
      rel="noreferrer noopener"
      className={cn('hover:opacity-60', className)}
    >
      外資就活総合研究所
    </Button>
  );
};
